import { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form, Field } from 'redux-form';

import { SelectField } from 'common/components/forms';
import { FormError, Button } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import {
  updateAndProcessClubSignup,
  sendToHostedPayment
} from 'redux/clubSignup/actions';
import { listCustomerCreditCards } from 'redux/customerCreditCards/actions';

import HostedPaymentRedirectHiddenForm from './HostedPaymentRedirectHiddenForm';
import { validateCreditCard } from './validators';

const Payment = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [redirectObj, setRedirectObj] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(listCustomerCreditCards());
  }, [dispatch]);

  const onSubmit = (form) => {
    const data = transformData(form);
    const clubSignup = {
      creditCard: data,
      clubId: props.club.id
    };
    const successFunction = (membership) => {
      props.history.push(`/club/receipt/${membership.id}`);
    };
    dispatch(updateAndProcessClubSignup(clubSignup, successFunction));
  };

  const handleBack = (e) => {
    e.preventDefault();
    props.onEdit('billing');
  };

  const handleSendToHostedPayment = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const redirectFunction = (response) => {
      setRedirectObj(response);
    };
    dispatch(sendToHostedPayment(redirectFunction));
  };

  // const { handleSubmit, form } = this.props;
  // const { customerCreditCards } = this.props;
  // const { selectedCreditCardId } = this.props;

  const customerCreditCardsReducer = useSelector(
    (state) => state.customerCreditCard
  );

  if (redirectObj) {
    return <HostedPaymentRedirectHiddenForm redirectObj={redirectObj} />;
  }
  if (
    customerCreditCardsReducer.isFetching ||
    !customerCreditCardsReducer.data
  ) {
    return null;
  }
  const { handleSubmit, form } = props;
  const hasCreditCards = customerCreditCardsReducer.query.length > 0;
  if (hasCreditCards) {
    const creditCardArrayIds = Object.keys(customerCreditCardsReducer.data);
    const customerCreditCardArray = creditCardArrayIds.map(
      (creditCardId) => customerCreditCardsReducer.data[creditCardId]
    );
    let clubSignup = 'Club';
    if (isPreSale()) {
      clubSignup = 'Pre-Sale';
    }
    return (
      <Form onSubmit={handleSubmit(onSubmit)} className="c7-form" method="post">
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>
        <Field
          name="customerCreditCardId"
          component={SelectField}
          optionArray={creditCardOptionArray(customerCreditCardArray)}
          label="Credit Card"
          required
        />
        <div style={{ textAlign: 'center' }}>
          <a href="" onClick={handleSendToHostedPayment}>
            Enter a new payment method
          </a>
        </div>
        <div className="c7-checkout__content__buttons">
          <Button type="submit" className="c7-button" disabled={isSubmitting}>
            Complete {clubSignup} Sign Up
          </Button>
          <a
            href="#"
            aria-label="Return to shipping method"
            onClick={handleBack}
          >
            Return to billing information
          </a>
        </div>
      </Form>
    );
  }
  return (
    <>
      <h3>Payment method</h3>
      <p>All transactions are secure and encrypted.</p>
      <p>&nbsp;</p>
      <div style={{ textAlign: 'center' }}>
        <Button
          type="button"
          className="c7-button"
          disabled={isSubmitting}
          onClick={handleSendToHostedPayment}
        >
          Proceed to Payment
        </Button>
      </div>
      <p>&nbsp;</p>
      <div className="c7-checkout__content__buttons">
        <a href="" onClick={handleBack}>
          Return to billing information
        </a>
      </div>
    </>
  );
};

const creditCardOptionArray = (creditCards) => {
  const array = [];
  creditCards.forEach((creditCard) => {
    array.push({ option: creditCardOneLine(creditCard), value: creditCard.id });
  });
  return array;
};

const creditCardOneLine = (card) =>
  `${card.maskedCardNumber} Exp: ${card.expiryMo}/${card.expiryYr}`;

const transformData = (values) => {
  const data = {
    customerCreditCardId: values.customerCreditCardId
  };

  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateCreditCard(data);
  return errors;
};

const mapStateToProps = (state) => {
  const initialValues = {};
  if (state.clubSignup && state.clubSignup.data) {
    const { creditCard } = state.clubSignup.data;
    if (creditCard) {
      initialValues.customerCreditCardId = creditCard.customerCreditCardId;
    }
  }
  if (!initialValues.customerCreditCardId) {
    initialValues.customerCreditCardId = state.customerCreditCard?.query?.[0];
  }
  return {
    initialValues
  };
};

const PaymentForm = reduxForm({
  form: 'paymentLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(connect(mapStateToProps)(PaymentForm));
